<footer class="py-1 footerspinea" style="background-color:#dd0a0a;">
    <div class="container" >
        
        <p class="m-0 text-center text-white">
                 SPINEA, s.r.o., Ku Magašu 702/3,
                080 01 Haniska, District of Prešov, Slovakia
        </p>
        <p class="m-0 text-center text-white">
                +421 51 7700 156&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

                 <img width="28" height="28" alt="" [src]="AssetbasePath + '/Content/MainImages/ico-mail-circle.svg'" />
                <a href=" mailto: sales@spinea.com" class="text-white">&nbsp;&nbsp;sales&#64;spinea.com</a>
        </p>
        <p class="m-0 text-center text-white">
                <!--[Copyright, all rights reserved]-->

                ©2025  Cone Drive Operations, Inc. All rights reserved.
                <a href="https://www.timken.com/terms-of-use/" class="text-white" style="margin: 0 5px;" target="_blank">Terms of Use</a>
                <a href="https://www.timken.com/privacy-statement/" class="text-white" style="margin: 0 5px;" target="_blank">Privacy Statement</a>
        </p>
        
        <!-- <input id="hostpath" type="hidden" value="@hostName" /> -->
    </div>
</footer>


